import React from 'react';
import './Loading.css';
import './../spinner/Spinner';
import Spinner from './../spinner/Spinner';

const Loading = props => {
    return (
        <div className="loadingPage">
            <Spinner />
        </div>
    )
}


export default Loading;